import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import {
  About,
  Consulting,
  DataDictionary,
  EmailVerified,
  // Expenditures,
  Home,
  House,
  HouseLanding,
  Login,
  Methodology,
  Results,
  // Scenario,
  Senate,
  SenateLanding
} from '@/pages'

Vue.use(Router)
Vue.use(Meta)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    }
  }, {
    path: '/email-verified',
    name: 'email_verified',
    component: EmailVerified
  }, {
    path: '/about',
    name: 'about',
    component: About
  }, {
    path: '/methodology',
    name: 'methodology',
    component: Methodology
  }, {
    path: '/consulting',
    name: 'consulting',
    component: Consulting
  }, {
    path: '/data-dictionary',
    name: 'data_dictionary',
    component: DataDictionary,
    meta: {
      fluid: true
    }
  // }, {
  //   path: '/simulator',
  //   name: 'calculator',
  //   component: Expenditures,
  //   meta: {
  //     fluid: true
  //   }
  // }, {
  //   path: '/simulator/report',
  //   name: 'scenario',
  //   component: Scenario,
  //   meta: {
  //     fluid: true
  //   }
  }, {
    path: '/house',
    name: 'house_landing',
    component: HouseLanding
  }, {
    path: '/house/:raceId',
    name: 'house',
    component: House
  }, {
    path: '/results',
    name: 'results',
    component: Results
  }, {
    path: '/senate',
    name: 'senate_landing',
    component: SenateLanding
  }, {
    path: '/senate/:raceId',
    name: 'senate',
    component: Senate
  }, {
    path: '*',
    redirect: '/'
  }
]
// .map(route => ({
//   ...route,
//   meta: {
//     auth: process.env.NODE_ENV === 'production' ? true : undefined,
//     ...route.meta
//   }
// }))

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to) {
    // if (to.hash) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve({
    //         selector: to.hash,
    //         // offset: { x: 0, y: 80 }
    //       })
    //     }, 300)
    //   })
    // }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth === false && Vue.$auth.authenticated === true) {
    next('/')
  } else if (to.meta.auth === true && Vue.$auth.authenticated === false) {
    next('login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js